import Divider from 'components/common/Divider';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Alert, Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SocialAuthButtons from './SocialAuthButtons';
import { login } from 'functions/userAuth';
import { useNavigate  } from 'react-router-dom';
import { getPublicIPAddress, getTimezoneOffset } from 'functions/utils';


const LoginForm = ({ hasLabel, layout }) => {
  const navigate = useNavigate();

  // State
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    remember: false
  });

  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(null);
  const [attempts, setAttempts] = useState(0);

  const { username, password } = formData;

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);

    const publicIP = await getPublicIPAddress();
    const timeZoneOffset = getTimezoneOffset().toString();

    const formData = {
      userName: username,
      password: password,
      publicIP: publicIP,
      gmtOffset: timeZoneOffset
    };
    try {
      const res = await login(formData);
      console.log('auth login llooo ', res);
       //const { data } = res.response;

   
      setMessage('Authenticted');
      const deepLink=sessionStorage.getItem('deepLink');
      console.log('deepLink ', deepLink);
      console.log('deepLink',deepLink);
      if(!deepLink){
        navigate('/support-desk/table-view');
      }
      else{
        navigate(deepLink);
      }
      setAttempts(0); // reset attempts on success
    } catch (err) {
      console.log('auth err ', err);
      if (err.response && err.response.status === 429) {
        setMessage('You should contact the support agent and read your email for more details.');
        setAttempts(5);
      } else if(err.response && err.response.status===401){
        let warnMsg = 'Invalid username or password.';
        setAttempts(prev => {
          const next = prev + 1;
          console.log('Login attempt:', next);
          if(next >= 5){
            warnMsg = 'Too many failed attempts. Redirecting to Forgot Password...';
            setTimeout(() => {
              navigate(`/authentication/${layout}/forgot-password`);
            }, 2000);
          }
          
          setMessage(warnMsg);
          return next;
        });
      }
    } finally {
      setLoading(false);
    }
  };



  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Email address</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Username' : ''}
          value={formData.username}
          name="username"
          onChange={e => {
            setFormData({ ...formData, username: e.target.value });
          }}
          type="text"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Password</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Password' : ''}
          value={formData.password}
          name="password"
          onChange={e => {
            setFormData({ ...formData, password: e.target.value });
          }}
          type="password"
        />
      </Form.Group>

      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          {/* {JSON.stringify(formData)} */}
          <Form.Check type="checkbox" id="rememberMe" className="mb-0">
            <Form.Check.Input
              type="checkbox"
              name="remember"
              checked={formData.remember}
              onChange={e =>
                setFormData({
                  ...formData,
                  remember: e.target.checked
                })
              }
            />
            <Form.Check.Label className="mb-0 text-700">
              Remember me
            </Form.Check.Label>
          </Form.Check>
        </Col>

        <Col xs="auto">
          <Link
          disabled={true}
            className="fs--1 mb-0"
            to={`/authentication/${layout}/forgot-password`}
          >
            Forgot Password?
          </Link>
        </Col>
      </Row>

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={loading} //{!formData.username || !formData.password}
        >
          {loading ? (
            <>
              {' '}
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />{' '}
              Authenticating...
            </>
          ) : (
            'Log in'
          )}
        </Button>
      </Form.Group>

      {message && (
        <Form.Group>
          <br />
          <Alert variant={attempts >= 5 ? 'warning' : 'danger'}>{message}</Alert>
        </Form.Group>
      )}

      <Divider className="mt-4">or log in with</Divider>

      <SocialAuthButtons />
    </Form>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

LoginForm.defaultProps = {
  layout: 'simple',
  hasLabel: false
};

export default LoginForm;
